import Icons from 'assets/icons';
import images from 'assets/images/images'
import { useRequest } from 'hooks/useRequest';
import React, { useEffect, useRef, useState } from 'react'
import {useDispatch, useSelector} from 'react-redux';
import { Link, useNavigate } from 'react-router-dom'
import {setUserInfo} from 'redux/features/general/generalSlice';
import auth from 'utils/Auth';
import NavbarTab from './NavbarTab';
import useTranslate from 'hooks/useTranslate';
import {dataLayerPush} from 'utils/Datalayer';


const NavbarProfile = ({langs, handleChangeLang}) => {
    const [openMenu, setOpenMenu] = useState(false)
    const dispatch = useDispatch()
    const closeRef = useRef(null)
    const navigate = useNavigate();
    const [request] = useRequest()
    const {t} = useTranslate()
    const { userInfo, openStatus } = useSelector(state => state.general)
    const [openLang, setOpenLang] = useState(false)



    const menuItems = auth?.isGuest() ?[
        {
            name: t('receiverInfo'),
            icon: images.profile,
            id: 0,
            url: "/hesabim"
        },
        {
            name: t('addressesInfo'),
            icon: images.pinmapOrange,
            id: 1,
            url: "/adreslerim"
        },
        {
            name: t('orderTracking'),
            icon: images.receipt,
            id: 2,
            url: "/siparislerim"
        },
        {
            name: t('languageSelect'),
            icon: images.globe,
            id: 2,
            url: "/"
        },
        {
            name: t('logoutBtn'),
            icon: images.logout,
            id: 3,
            url: "/"
        },
    ] : [
        {
            name: t('myAccount'),
            icon: images.profile,
            id: 0,
            url: "/hesabim"
        },
        {
            name: t('myAddresses'),
            icon: images.pinmapOrange,
            id: 1,
            url: "/adreslerim"
        },
        {
            name: t('myorders'),
            icon: images.receipt,
            id: 2,
            url: "/siparislerim"
        },
        {
            name: t('languageSelect'),
            icon: images.globe,
            id: 2,
            url: "/"
        },
        {
            name: t('logoutBtn'),
            icon: images.logout,
            id: 3,
            url: "/"
        },
    ]

    const menuFunc = () => {
        setOpenMenu(!openMenu)
    }

    const redirectFunc = (id, url) => {
        if (id == 3) {
            let cookiesAccept  = auth?.getCookieAcception()
            localStorage.clear();
            sessionStorage.clear();
            dataLayerPush({
                event:"log_out",
                user_id:userInfo?.userId,
                user_phone:userInfo?.phone,
                user_email :userInfo?.email,
            })
            if(cookiesAccept){
                auth.setCookieAcception(cookiesAccept)
            }
            window.location = url
        } else {
            navigate(url)
        }
        setOpenMenu(!openMenu)

    }

    useEffect(() => {
        if (auth.isHaveToken()) {
            request('/Profile', {
                method: 'GET',
            }).then((res) => {
                if (res?.data?.result) {
                    dispatch(setUserInfo(res.data.result))
                }
            })
        }

    }, [auth.isHaveToken()]);

    useEffect(() => {
        if (openStatus) {
            setOpenMenu(false)
        }
    },[openStatus ])
    const closeOpenMenus = (e)=>{
        if(closeRef.current && openMenu && !closeRef.current.contains(e.target)){
          setOpenMenu(false)
        }
    }

    document.addEventListener('mousedown',closeOpenMenus)
	const parameters = auth.getUserChoises();
    const isSearchOpen = parameters?.deliveryType &&
    parameters?.neighbourhoodId &&
    parameters?.restaurantId &&
    (parameters?.deliveryType == 1 || parameters?.regionId)
    return (
        auth.isHaveToken() ? <div className='navbar-profile'>
           
            <div onClick={menuFunc} className="navbar-profile-menu-wrapper">
                <img  src={images.hamburger} alt="" />
            </div>
            {
                openMenu && <div ref={closeRef} className="navbar-profile-menu">
                     {
                        auth.isHaveToken() && <div className="navbar-profile-menu-tabs">
                            <NavbarTab isSearchOpen={isSearchOpen}/>
                        </div>
                     }
                    <div className='navbar-profile-menu-item restaurantName'>
                      <Icons.location size={22}/>
                      <div className='body-m'>{auth?.getUserChoises()?.restaurantName}</div> 
                    </div>
                    
                    {
                        menuItems.map((menu, i) => {
                            if (menu.name == t('languageSelect')) {
                                return <div key={i} className='navbar-profile-menu-item lang' onClick={() => setOpenLang(!openLang)}>
                                <img src={menu.icon} alt="" />
                                <div className='d-flex gap-3'><div>{menu.name}</div> <div className='lang-text'>{langs.map(l => {
                                    return <>
                                    <span key={l.value} className={`${l.value == JSON.parse(localStorage.getItem('lang')) ? 'text-orange': ''}`}>{l.label}</span>
                                    <span>{l.value == 'tr' && ' | '}</span>
                                    </>
                                })}</div> </div>
                                {
                                    openLang && <div className="navbar-profile-menu-item-dropdown">
                                    {
                                        langs.map(l => (<div onClick={() =>{
                                            handleChangeLang({...l})
                                            setOpenLang(false)
                                        }} key={l.value}>{l.label}</div>))
                                    }
                                </div>
                                }
                            </div>
                            } else {
                                return <div onClick={() => redirectFunc(menu.id, menu.url)} key={i} className='navbar-profile-menu-item'>
                                <img src={menu.icon} alt="" />
                                <div className='d-flex flex-column'><span>{menu.name}</span> <span>{i == 0 && `${userInfo?.fullName}`}</span></div>
                            </div>
                            }
                        })
                    }
                </div>
            }
        </div> :
            !auth.isHaveToken() &&
            <div className="d-flex justify-content-center">
                <Link to={'/uye-girisi'} className='navbar-loginBtn '>{t('loginBtn')}</Link>
                <Link to={'/kayit-ol'} className='navbar-registerBtn'>{t('registerBtn')}</Link>
                <div className='navbar-profile'>
           
            <div onClick={menuFunc} className="navbar-profile-menu-wrapper unauthorized">
                <img  src={images.hamburger} alt="" />
            </div>
            {
                openMenu && <div ref={closeRef} className="navbar-profile-menu">
                     {
                        auth.isHaveToken() && <div className="navbar-profile-menu-tabs">
                            <NavbarTab isSearchOpen={isSearchOpen}/>
                        </div>
                     }
                     {
                        auth?.getUserChoises()?.restaurantName &&  <div className='navbar-profile-menu-item restaurantName'>
                        <Icons.location size={22}/>
                        <div className='body-m'>{auth?.getUserChoises()?.restaurantName}</div> 
                      </div>
                     }
                    {
                        menuItems.filter(m => m.name == t('languageSelect')).map((menu, i) => {
                            if (menu.name == t('languageSelect')) {
                                return <div key={i} className='navbar-profile-menu-item lang' onClick={() => setOpenLang(!openLang)}>
                                <img src={menu.icon} alt="" />
                                <div className='d-flex gap-3'><div>{menu.name}</div> <div className='lang-text'>{langs.map(l => {
                                    return <>
                                    <span key={l.value} className={`${l.value == JSON.parse(localStorage.getItem('lang')) ? 'text-orange': ''}`}>{l.label}</span>
                                    <span>{l.value == 'tr' && ' | '}</span>
                                    </>
                                })}</div> </div>
                                {
                                    openLang && <div className="navbar-profile-menu-item-dropdown">
                                    {
                                        langs.map(l => (<div onClick={() =>{
                                            handleChangeLang({...l})
                                            setOpenLang(false)
                                        }} key={l.value}>{l.label}</div>))
                                    }
                                </div>
                                }
                            </div>
                            } else {
                                return <div onClick={() => redirectFunc(menu.id, menu.url)} key={i} className='navbar-profile-menu-item'>
                                <img src={menu.icon} alt="" />
                                <div className='d-flex flex-column'><span>{menu.name}</span> <span>{i == 0 && `${userInfo?.fullName}`}</span></div>
                            </div>
                            }
                        })
                    }
                </div>
            }
        </div>
            </div>

    )
}

export default NavbarProfile